import type React from 'react'

import Lock from '../assets/recommendations/lock.svg'
import { logProduct } from '../helpers/logProduct'

type props = {
  icon: string
  warning?: string | React.ReactNode
  tip?: string | React.ReactNode
  title: string
  company?: string
  link: string
  generalExplanation: string | React.ReactNode
  specificExplanation: string | React.ReactNode
  product: string
  specificProduct?: string
}
export const Product: React.FC<props> = ({
  icon,
  warning,
  tip,
  title,
  company,
  link,
  generalExplanation,
  specificExplanation,
  product,
  specificProduct,
}) => {
  return (
    <div className="recommendation">
      {warning}
      {tip}
      <div className="divider" />

      <div className="product">
        <img className="image" alt="icon" src={icon} />
        <div className="meta">
          <div className="title">{title}</div>
          {company && <div className="company">{company}</div>}
        </div>

        {link && (
          <button
            type="button"
            onClick={() => {
              logProduct(product, company, title)
              setTimeout(() => {
                window.location.href = link
              }, 1000)
            }}
            className="link button fcc recommendation-link"
          >
            <div className="fr">
              Learn more
              <img className="lock" alt="lock" src={Lock.src} />
            </div>
            <span className="disclosure">(On their website)</span>
          </button>
        )}
      </div>

      <p className="explanation">
        {!product.includes('card') && <strong>Why {product}: </strong>}
        {generalExplanation}
      </p>
      {specificProduct ? (
        <p className="explanation">
          <strong>Why {specificProduct}: </strong>
          {specificExplanation}
        </p>
      ) : (
        <div>{specificExplanation}</div>
      )}
    </div>
  )
}
